/**
 * @module common
 * @description 通用型別定義
 */
/** 結構化錯誤碼（前端依此判斷，不依賴 message 字串） */
export var ApiErrorCode;
(function (ApiErrorCode) {
    ApiErrorCode["TOTP_REQUIRED"] = "TOTP_REQUIRED";
    ApiErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ApiErrorCode["ACCOUNT_LOCKED"] = "ACCOUNT_LOCKED";
    ApiErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ApiErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ApiErrorCode["VALIDATION_FAILED"] = "VALIDATION_FAILED";
})(ApiErrorCode || (ApiErrorCode = {}));
//# sourceMappingURL=common.js.map